import { computed, Injectable, signal } from '@angular/core';
import { StorageKeys } from '@core/enums';
import { EMPTY_STRING } from '@core/utils';

@Injectable({
  providedIn: 'root'
})
export class GetCountryService {
  // Signal interno para reatividade
  private countrySignal = signal<string>(EMPTY_STRING);
  private countryComputed = computed(() => {
    const countryFromStorage = sessionStorage.getItem(StorageKeys.COUNTRY) || EMPTY_STRING;
    return this.countrySignal() || countryFromStorage;
  });

  /**
   * Obtém o país selecionado (reativo via signal)
   */
  getCountry(): string {
    return this.countryComputed();
  }

  /**
   * Define o país selecionado e sincroniza com sessionStorage
   */
  setCountry(country: string): void {
    this.countrySignal.set(country);
    sessionStorage.setItem(StorageKeys.COUNTRY, country);
  }
}

